<template>
  <!-- 仓库入库列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="AddBtns()"
          >新建</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="pushIntoStrockCheckScale()"
          >推送复测</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="checkScale()"
          >复测确认</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="cancelCheckScale()"
          >取消复测确认</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="intoStrockSureV4()"
          >入库确认</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="cancelIntoStrockSureV4()"
          >取消入库确认</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="checkScaleException()"
          >复测异议</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="handleCheckScaleException()"
          >异议处理</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="copyAdd()"
          >复制新增</el-button
        >
        <el-button class="itemBtn" @click="myModel"
        >表格设置</el-button
        >
        <el-dropdown class=" topDropDown" @command="printItNow">
          <el-button type="primary" >
            打印
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                :command="className.val"
                v-for="className in classNameArr"
                :key="className.val"
            >
              <div style="display: flex;">
                <span style="flex:1;padding-right:10px;">{{ className.name }}</span>
                <el-button type="text" @click.stop="printIt(className.val)">设置</el-button>
              </div>
            </el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <template >
          <div class="tableExportBtn">
            <exportTb
                :theadData="myTableHeard"
                :tableData="tableData"
                :resultData="tableData"
                @handleExportDia_dc="handleExportDia_dc('入库单列表')"
            ></exportTb>
          </div>
        </template>


<!--        <el-dropdown class=" topDropDown" @command="handleCommand_dc">-->
<!--          <el-button class="dropdownBtn">-->
<!--            导出<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </el-button>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item command="dc">导出</el-dropdown-item>-->
<!--            <el-dropdown-item command="dcmb">下载导出模板</el-dropdown-item>-->
<!--            <el-dropdown-item command="scmb">保存(上传)模板</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->

<!--        <el-dropdown class=" topDropDown" @command="topCommandBtns">-->
<!--          <el-button type="primary">-->
<!--            更多操作-->
<!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </el-button>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item command="dtdc">导出</el-dropdown-item>-->
<!--            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="ModifyBtns(scope.row)"
                >修改</el-button
              >
              <el-button class="rbtns" @click.stop="getDetailBtns(scope.row)"
                >详情</el-button
              >
              <el-button class="rbtns" @click.stop="delIntoStock(scope.row)"
                >作废</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                  class="rbtns"
                  @command="handleCommandBtns($event, scope.row)"
                >
                  <el-button type="primary">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">详情</el-dropdown-item>
                    <el-dropdown-item command="b">外发录入</el-dropdown-item>
                    <el-dropdown-item command="c">改运单号</el-dropdown-item>
                    <el-dropdown-item command="d">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable>

    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>

    <my-print
        :classNameArr="classNameArr"
        :modelClassName.sync="modelClassName"
        :getApiType.sync="getApiType"
        modelTypeVal="print_data_into_stock_bill"
        ref="myPrint"
        :dataSource="printDataSource"
        :add-permission="printPermission"
        :edit-permission="printPermission"
        :del-permission="printPermission"
        :printClassName="printClassName"
        :conditonKey="conditonKey"
        :printId="printId"
    ></my-print>
<!--    <printDialog-->
<!--        :dialogFrom="dialogFrom"-->
<!--        :printClassName="printClassName"-->
<!--        :conditonKey = "conditonKey"-->
<!--        :printId="printId"-->
<!--    ></printDialog>-->
  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
  import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import MyPrint from "@/components/print/MyPrint.vue";
// import printDialog from "@/components/printDialog/index.vue";
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
  import exportTb from "@/components/exportComponent/exportTb.vue"; //导出
  import exportComponent from "@/components/exportComponent/index.vue"; //

export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    MyPrint,
      sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    // printDialog,
    exportTb,
    exportComponent
  },
  data() {
    return {
      sortName:  "仓库入库列表",
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "仓库入库列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListIntoStockList", //  页面标识
      reportFiledsNumber: "into_stock_bill_list_v4", // 动态 条件、表头

      currentItemArr: [],
      dialogType: "",
      showTimers:false,
      classNameArr: [
        {
          name: "标签打印",
          val: "print_data_into_stock_bill",
        },
      ], // 默认的模板类型
      modelClassName:
          "print_data_into_stock_bill",
      printClassName:  "print_data_into_stock_bill",
      conditonKey: 'intoStockIds',
      apiNumber: 'print_data_into_stock_bill',
    };
  },
  mounted() {
    this.queryBtn_ok();
  },
  watch: {},
  methods: {
    //新增入库单
    AddBtns(){
      this.$router.push({
        path: "/pages/v4/intoStock/addIntoStock",
        query: {
          pageType: "add",
        }
      });
    },
    //修改入库单
    ModifyBtns(row){
      this.$router.push({
        path: "/pages/v4/intoStock/editIntoStock",
        query: {
          intoStockId: row.intoStockId,
          pageType: "edit",
        },
      });
    },
    //入库单详情
    getDetailBtns(row){
      this.$router.push({
        path: "/pages/v4/intoStock/detailIntoStock",
        query: {
          intoStockId: row.intoStockId,
          pageType: "detail",
        },
      });
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
      this.selectTableData = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },

    //推送复测
    delIntoStock(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要作废的入库单");
        return false;
      }
      this.$confirm("是否作废所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [];
            list.forEach((item) => {
              ids.push(item.intoStockId);
            });
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.delIntoStock(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },

    //推送复测
    pushIntoStrockCheckScale(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要推送复测的入库单");
        return false;
      }
      this.$confirm("是否推送复测所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [];
            list.forEach((item) => {
              ids.push(item.intoStockId);
            });
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.pushIntoStrockCheckScale(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },
    //复测确认
    checkScale(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要复测确认的入库单");
        return false;
      }
      this.$confirm("是否复测确认所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [];
            list.forEach((item) => {
              ids.push(item.intoStockId);
            });
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.checkScale(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },
    //取消复尺确认
    cancelCheckScale(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要取消复测确认的入库单");
        return false;
      }
      this.$confirm("是否取消复测确认所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [];
            list.forEach((item) => {
              ids.push(item.intoStockId);
            });
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.cancelCheckScale(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },
    //入库确认
    intoStrockSureV4(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要入库确认的入库单");
        return false;
      }
      this.$confirm("是否入库确认所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [];
            list.forEach((item) => {
              ids.push(item.intoStockId);
            });
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.intoStrockSureV4(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },
    //取消入库确认
    cancelIntoStrockSureV4(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要取消入库确认的入库单");
        return false;
      }
      this.$confirm("是否取消入库确认所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [];
            list.forEach((item) => {
              ids.push(item.intoStockId);
            });
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.cancelIntoStrockSureV4(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },
    //复测异议
    checkScaleException(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要复测异议的入库单");
        return false;
      }
      if (list.length > 1) {
        this.$message.error("请选择一条数据");
        return false;
      }
      this.$router.push({
        path: "/pages/v4/intoStock/checkScaleException",
        query: {
          intoStockId: list[0].intoStockId,
          documentNumber: list[0].intoStockNumber,
          memberId: list[0].memberId,
          memberName: list[0].memberName,
          memberTab: list[0].memberTab,
          pageType: "addException",
          userMemberId: list[0].userMemberId,
        },
      });
    },
    //异议处理
    handleCheckScaleException(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要异议处理的入库单");
        return false;
      }
      if (list.length > 1) {
        this.$message.error("请选择一条数据");
        return false;
      }
      //查询异常信息
      let obj = {
        conditonKey: "intoStockId",
        conditonVal: list[0].intoStockId,
      };
      let param = {
        conditionReqs: [obj],
        number: 'into_stock_exist_yiyi_exception',
      }
      this.$API.runReport(param).then((res) => {
        let datas = res.data.result.datas || [];
        if (!datas) {
          this.$message.success("暂无复测异议需要处理");
          return;
        }
        let resultData = datas[0];
        if(1 !== resultData.hasException){
          this.$message.success("暂无复测异议需要处理");
          return;
        }
        this.$router.push({
          path: "/pages/v4/intoStock/handleScaleException",
          query: {
            intoStockId: list[0].intoStockId,
            pageType: "handleException",
          },
        });
      });



    },
    //复制新增
    copyAdd(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 0) {
        this.$message.error("请选择需要复制新增的入库单");
        return false;
      }
      if (list.length > 1) {
        this.$message.error("请选择一条数据");
        return false;
      }
      this.$router.push({
        path: "/pages/v4/intoStock/addIntoStock",
        query: {
          intoStockId: list[0].intoStockId,
          pageType: "copyAdd",
        },
      });
    },

    // =============打印
    printIt(command) {
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择1条打印的数据");
        return;
      }
      console.log("设置")
      this.modelClassName = command;

      switch (command) {
        case "print_waybill_table_data":
          this.getApiType = true;
          break;
        case "print_quan_da_waybill_data":
          this.getApiType = true;
          break;
        case "print_tao_da_waybill_data":
          this.getApiType = true;
          break;
        default:
          this.getApiType = false;
          break;
      }
      this.printId = this.selectTableData.map((d) => d.intoStockId);
      this.$nextTick(() => {
        this.printSetting();
      })
    },
    printItNow(command) {
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择1条打印的数据");
        return;
      }
      console.info("直接打印")
      this.modelClassName = command;

      switch (command) {
        case "print_waybill_table_data":
          this.getApiType = true;
          break;
        case "print_quan_da_waybill_data":
          this.getApiType = true;
          break;
        case "print_tao_da_waybill_data":
          this.getApiType = true;
          break;
        default:
          this.getApiType = false;
          break;
      }
      this.printId = this.selectTableData.map((d) => d.intoStockId);
      this.$nextTick(() => {
        this.printEventNow();
      })
    },
    printDataSource(rows) {
      return new Promise((resolve, reject) => {
        this.$API
            .runList({
              number: this.printClassName,
              intoStockIds: rows.map((d) => d.intoStockId),
            })
            .then((res) => {
              const result = res;
              resolve(result);
            })
            .catch((err) => {});
      });
    },
    printPermission(action) {
      let scope = "";
      switch (this.modelClassName) {
        default:
          scope = "common";
          break;
      }
      console.log(scope);
      return "admin:waybill:print:" + action + ":" + scope;
    },
  },
};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}

</style>
  